import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <p>
        Netflix Clone designed by <span>UMAR</span>
      </p>
    </footer>
  );
}

export default Footer;
